<template>
  <section class="app-authorization">
    <header class="header">
      <img src="../../assets/images/logo.png" class="logo"/>
    </header>
    <div class="content">
      <p class="title">经销商管理系统应用授权开通</p>
      <p>需企业微信管理员使用企业微信扫一扫对需要使用的应用分别授权开通</p>
      <div class="app-author-box">
        <ul class="app-author-ul clearfix">
          <li v-for="item in appAuthorList" :key="item.name">
            <div class="box-img"><img :src="item.logo"/></div>
            <span class="name">{{ item.name }}</span>
            <button class="app-author-btn" @click="onClick(item.url)">授权开通</button>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer-info">
      <span>Copyright ©  2016-{{ currentYear }} 深圳市立新出行信息技术有限公司 版权所有</span>
      <div class="footer-info__content">
        <a class="footer-info__item" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备15082797号</a>
        <span>增值电信业务经营许可证：</span>
        <a class="footer-info__item" target="_blank" href="https://dxzhgl.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%25E6%25B7%25B1%25E5%259C%25B3%25E5%25B8%2582%25E7%25AB%258B%25E6%2596%25B0%25E5%2587%25BA%25E8%25A1%258C%25E4%25BF%25A1%25E6%2581%25AF%25E6%258A%2580%25E6%259C%25AF%25E6%259C%2589%25E9%2599%2590%25E5%2585%25AC%25E5%258F%25B8&type=xuke">粤B2-20210668</a>
      </div>
    </div>
  </section>
</template>

<script>
import { Message } from 'element-ui'
export default {
  data() {
    return {
      appAuthorList: [],
      currentYear: (new Date()).getFullYear()
    }
  },
  created() {
    this.$rest.Auth.getAuthInfo().then((res) => {
      if (res.code === 0) {
        this.appAuthorList = res.data
      } else {
        Message.error(res.message)
      }
    })
  },
  methods: {
    onClick(url) {
      if (url) {
        window.location.href = url
      } else {
        Message.error('登录接口未返回微信企业号登录url')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.clearfix:after {
    display: table;
    content: " ";
    clear: both;
}
.clearfix{
    *zoom: 1;
}
.app-authorization {
  .header {
    position: relative;
    width: 100%;
    height: 50px;
    background-image: linear-gradient(135deg, #1ba2fc 0%, #1967fb 100%);
    box-shadow: 0px 0px 8px 0px rgba(0, 79, 238, 0.5);
    .logo {
      position: absolute;
      left: 23px;
      top: 10px;
    }
  }
  .content {
    margin: 40px 0;
  }
  p {
    margin-left: 130px;
    line-height: 2;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
  }
  .app-author-box {
    width: 1262px;
    margin: 0 auto;
    overflow: hidden;
  }
  .app-author-ul {
    margin-top: 50px;
    margin-right: -270px;
    li {
      float: left;
      margin-right: 270px;
      margin-bottom: 80px;
    }
    .box-img {
      width: 110px;
      height: 110px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name, .app-author-btn {
      text-align: center;
    }
    .name {
      display: block;
      margin: 15px 0;
    }
    .app-author-btn {
      width: 100%;
      height: 30px;
      line-height: 30px;
      background-color: #1ba2fc;
      color: #fff;
      &:hover {
        background-color: #078be4;
      }
    }
  }
}

.footer-info {
  width: 100%;
  padding-bottom: 12px;
  text-align: center;
  color: #333;

  &__content {
    padding-top: 10px;
  }

  &__item {
    margin-right: 14px;
    color: #333;
  }
}
</style>
